/* eslint react/no-did-mount-set-state: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextAccordion from '../../components/common/text-accordion/TextAccordion';

const SEOTextComponent = ({
    baseCls = 'text-accordion',
    containerCls = 'seo-text',
    panelIDPrefix = 'seo-description-type',
    slpText,
    isRefined,
}) => {
    const text = slpText.map(
        ({content, seoDescriptionType: panelID, type, title, titleTag}) => ({
            content,
            panelID,
            type,
            title,
            titleTag,
        })
    );

    const computedContainerCls = classNames(
        {
            'module--no-margin ': !text.length,
        },
        `${isRefined ? 'refined-' : ''}${containerCls}`
    );

    return (
        <TextAccordion
            baseCls={baseCls}
            containerCls={computedContainerCls}
            panelIDPrefix={panelIDPrefix}
            text={text}
            headingStyle={isRefined ? 'dynamic' : 'span'}
        />
    );
};

const slpTextItem = PropTypes.shape({
    content: PropTypes.string,
    seoDescriptionType: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    titleTag: PropTypes.string,
});

SEOTextComponent.propTypes = {
    baseCls: PropTypes.string,
    containerCls: PropTypes.string,
    panelIDPrefix: PropTypes.string,
    slpText: PropTypes.arrayOf(slpTextItem),
};

export default React.memo(SEOTextComponent);
